import React, { useEffect, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { Spine } from '../../../../core/classes/spine';
import BoostedJackpotPopupDate from '../../boostedJackpot/boostedJackpotPopupDate';

function BoostedJackpotIconView({
  isDisabled,
  animationName,
  handlePointerUp,
  boostedJackpotIconInfoBoard,
}) {
  const iconBoardRef = useRef(null);
  useEffect(() => {
    if (iconBoardRef.current) {
      const wheelIcon = new Spine({ key: 'wheelIcon' });
      iconBoardRef.current.addChild(wheelIcon);
    }
  }, [iconBoardRef]);

  useEffect(() => {
    iconBoardRef.current.children[0].stop();
    iconBoardRef.current.children[0].play(animationName, true);
  }, [animationName]);

  return (
    <Container
      interactive={isDisabled}
      cursor='pointer'
      name='BoostedJackpotIcon'
      pointerup={handlePointerUp}
    >
      <Container ref={iconBoardRef} />
      <Container y={30}>
        <Sprite texture={boostedJackpotIconInfoBoard} anchor={0.5} />
        <BoostedJackpotPopupDate
          x={-20}
          y={-65}
          isIcon
          marginInText={10}
          marginInContainer={30}
          hiderTextXPosition={5}
          durationTextPositions={{ x: 126, y: 30 }}
          stylesTimer={{
            _fontSize: 14,
            _fontWeight: 600,
            _fontFamily: 'poppinsMedium',
            _fill: '#FFC33E',
            align: 'center',
          }}
        />
      </Container>
    </Container>
  );
}

export default BoostedJackpotIconView;
